import { useApplicationModals } from "app/common/hooks";
import { Button, IconButton } from "app/components/atoms/button";
import { InputLabel } from "app/components/atoms/form";
import { InputMolecule } from "app/components/molecules/form";
import { ModalMolecule } from "app/components/molecules/modal";
import api, { stockOpname } from "app/integration/api";
import { useCollector, useCreateForm } from "app/integration/common/hooks";
import { Formik, getIn } from "formik";
import * as Yup from "yup";
import AppModals from ".";
import { useState, useRef, useCallback, useEffect } from "react";
import Table from "app/components/atoms/table";
import { SelectMolecule, SelectSearchMolecule } from "app/components/molecules/select";
import { TrashIcon } from "@heroicons/react/24/outline";

function CreateScrap({ onSuccess = () => { } }) {
  let isError = false;
  const { showStates, closeModal, getPayloads, openModal, setPayloads } =
    useApplicationModals();

  const handleClose = () => {
    closeModal("scrap.create");
    // Clear both input and qrCode state after processing
    setQrCode("");
    setProductScrap([]);
  };
  const handleSuccess = () => {
    closeModal("scrap.create");
    onSuccess();
  };

  const [productVariants] = useCollector({ modelName: "productVariant" });
  const [qrCode, setQrCode] = useState("");
  const scanBarcodeInputRef = useRef(null);
  const [productScrap, setProductScrap] = useState([]);
  const [productVariantId, setProductVariantId] = useState(null);

  const { initialValues, validationSchema, onSubmit, setFieldValue } = useCreateForm({
    initialValues: {
      code: "",
      product_variant_id: null,
      qty: 0,
      reason: "",
      status: "pending",
      description: "",
    },
    validationSchema: Yup.object().shape({
      code: Yup.string().required("Kode harus diisi"),
      product_variant_id: Yup.number().required("Variant harus diisi"),
      qty: Yup.number().required("Jumlah harus diisi")
        .min(1, "Jumlah harus lebih dari 0."),
      reason: Yup.string().required("Alasan harus diisi"),
      description: Yup.string().optional(),
      status: Yup.string().required("Status harus diisi"),
    }),
    onSubmit: async (values) => {
      try {
        const productVariant = productVariants.find(
          (item) => item.id === values.product_variant_id
        );
        await api.scrap.store(
          values.code,
          productVariant?.product_detail?.name,
          values.product_variant_id,
          values.qty,
          values.reason,
          values.description,
          values.status
        );

        if (values?.status === "approved") {
          for (let i = 0; i < productScrap.length; i++) {
            await api.productCode.update(
              productScrap[i]?.id,
              {
                status: values.status,
                scan_scrap_date: new Date(),
              }
            );
          }
        }
        isError = false;
      } catch (error) {
        setPayloads("errorMessage.view", {
          title: "Add Stock Opname Error",
          message: error?.response?.data?.message,
        });
        isError = true;
        openModal("errorMessage.view");
      }
    },
    onSuccess: () => {
      if (!isError) {
        handleSuccess();
      }
    },
  });

  const setItemOrder = useCallback(async (value) => {
    try {
      // Get product code directly from backend with specific QR code
      const response = await api.productCode.index({
        qr_code: value?.replace(/"/g, ""),  // Remove all quotes globally
        product_variant_id: productVariantId,
        limit: 1
      });

      const productCode = response.data[0];

      // Check if product code exists and is in warehouse status
      if (!productCode || productCode.status !== "warehouse") {
        console.warn(`Product code not found or not in warehouse for QR code: ${value}`);

        setPayloads("errorMessage.view", {
          title: "Scan Error",
          message: productCode ?
            `Product code ${value} is not in warehouse status` :
            `Product code not found for QR code: ${value}`,
        });
        isError = true;
        openModal("errorMessage.view");
        return null;
      }

      const responseVariant = await api.productVariant.index({
        id: productCode?.product_variant_id,
        limit: 1
      });

      const productVariant = responseVariant.data[0];
      // Check if product variant exists
      if (!productVariant) {
        console.warn(`Product variant not found for QR code: ${value}`);

        setPayloads("errorMessage.view", {
          title: "Tambah Customer Error",
          message: `Product variant not found for QR code: ${value}`,
        });
        isError = true;
        openModal("errorMessage.view");
        return null;
      }
      productCode.product_variant = productVariant;
      return productCode;
    } catch (err) {
      console.error("Error fetching product code:", err);
      setPayloads("errorMessage.view", {
        title: "API Error",
        message: err?.response?.data?.message || "Error fetching product code",
      });
      isError = true;
      openModal("errorMessage.view");
      return null;
    }
  }, [productVariants, setPayloads, openModal]);  // Add dependencies array

  const handleScanBarcodeChange = async (e, { setFieldValue, values }) => {
    // Immediately refocus the input after any change
    if (scanBarcodeInputRef.current) {
      scanBarcodeInputRef.current.focus();
    }

    if (values?.product_variant_id === null) {
      // Item scanned is not within shopping list
      setPayloads("errorMessage.view", {
        title: "Produk Varian tidak ditemukan",
        message: "Silahkan pilih Produk Varian terlebih dahulu.",
      });
      isError = true;
      openModal("errorMessage.view");
      // Clear both input and qrCode state after processing
      setQrCode("");
      return;
    }

    // Only process when Enter key is pressed
    if (e.key === "Enter" && e.target.value?.trim() !== "") {
      const qrValue = e.target.value.trim();
      setItemOrder(qrValue).then(async (itemOrder) => {
        // console.log("item is found: ", itemOrder);

        var isFound = false;
        const findProductScrap = productScrap?.find(
          (stock) => stock?.qr_code === itemOrder?.qr_code
        );
        console.log("findProductScrap", findProductScrap);
        if (itemOrder && !findProductScrap) {
          setProductScrap([...productScrap, itemOrder]);
          setQrCode(qrValue);
          isFound = true;
          setFieldValue("qty", values?.qty + 1);
        }

        if (!isFound && !findProductScrap) {
          // Item scanned is not within shopping list
          setPayloads("errorMessage.view", {
            title: "Product Tidak Ditemukan",
            message: "Produk tidak ditemukan di dalam daftar.",
          });
          isError = true;
          openModal("errorMessage.view");
        }
        // Clear both input and qrCode state after processing
        setQrCode("");
        e.preventDefault(); // Prevent default enter key behavior
      });
    }
  };

  const deleteItem = (index, values, setFieldValue) => {
    const newProductScrap = [...productScrap];
    newProductScrap.splice(index, 1);
    setProductScrap(newProductScrap);
    setFieldValue("qty", values?.qty - 1);
  };

  return (
    <ModalMolecule
      show={showStates["scrap.create"]}
      title="Tambah Scrap"
      onClose={handleClose}
      size="lg"
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form className="space-y-4 pb-24" onSubmit={handleSubmit}>
            <div className="grid md:grid-cols-2 gap-4">
              <InputMolecule testId="modal-create-scrap-code-input"
                label="Kode"
                type="text"
                name="code"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.code}
                errorMessage={errors.code && touched.code && errors.code}
              />
              <SelectSearchMolecule testId="modal-create-scrap-product-variant-id-select"
                label="Produk Variant"
                name="product_variant_id"
                options={productVariants?.map((productVariant) => ({
                  value: productVariant?.id,
                  label: `${productVariant?.product_detail?.name} (${productVariant?.color?.name}) (${productVariant?.size?.name})`,
                }))}
                onChange={(e) => {
                  handleChange(e);
                  setProductVariantId(e.target.value)
                }}
                onBlur={handleBlur}
                value={values.product_variant_id}
                errorMessage={
                  errors.product_variant_id &&
                  touched.product_variant_id &&
                  errors.product_variant_id
                }
              />
              <SelectMolecule testId="modal-create-scrap-status-select"
                label="Status"
                name="status"
                options={[
                  {
                    value: "pending",
                    label: "Pending",
                  },
                  {
                    value: "approved",
                    label: "Approved",
                  },
                  {
                    value: "rejected",
                    label: "Rejected",
                  },
                ]}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.status}
                errorMessage={
                  errors.status &&
                  touched.status &&
                  errors.status
                }
              />
              <InputMolecule testId="modal-create-scrap-reason-input"
                label="Alasan"
                type="text"
                name="reason"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.reason}
                errorMessage={
                  errors.reason &&
                  touched.reason &&
                  errors.reason
                }
              />
              <InputMolecule testId="modal-create-scrap-description-input"
                label="Deskripsi"
                type="text"
                name="description"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.description}
                errorMessage={
                  errors.description &&
                  touched.description &&
                  errors.description
                }
              />
              <div className="">
                <InputLabel>Scan Barcode Disini</InputLabel>
                <input data-testid="modal-create-scrap-scan-barcode-input"
                  className="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-gray-900 placeholder-gray-300 shadow-sm focus:border-primary-600 focus:outline-none disabled:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder-gray-500 autofill:dark:bg-gray-800 dark:disabled:bg-gray-800 focus:ring-1 focus:ring-primary-600"
                  type="text"
                  name="scan_barcode"
                  onChange={(e) => {
                    setQrCode(e.target.value);
                    handleScanBarcodeChange(e, { setFieldValue, values });
                  }}
                  onKeyDown={(e) => {
                    // Trigger scanning on Enter key
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevent the default form submission
                      handleScanBarcodeChange(e, { setFieldValue, values });
                    }
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    // Immediately refocus if blur occurs
                    if (scanBarcodeInputRef.current) {
                      scanBarcodeInputRef.current.focus();
                      scanBarcodeInputRef.current.select();
                    }
                  }}
                  value={qrCode}
                />
              </div>
              <InputMolecule testId="modal-create-scrap-qty-input"
                label="Stok"
                type="number"
                name="qty"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.qty}
                disabled
                errorMessage={
                  errors.qty &&
                  touched.qty &&
                  errors.qty
                }
              />
            </div>

            <Table.Container>
              <Table.Wrapper asIndex={false}>
                <Table.Header>
                  <Table.HeaderRow>
                    <Table.Heading>Barcode</Table.Heading>
                    <Table.Heading>Produk</Table.Heading>
                    <Table.Heading>Varian Warna</Table.Heading>
                    <Table.Heading>Varian Ukuran</Table.Heading>
                    <Table.Heading></Table.Heading>
                  </Table.HeaderRow>
                </Table.Header>
                <Table.Body>
                  {productScrap?.map((stockScrap, key) => (
                    <Table.BodyRow key={key}>
                      <Table.Cell>{stockScrap?.qr_code}</Table.Cell>
                      <Table.Cell>{stockScrap?.product_variant?.product_detail?.name}</Table.Cell>
                      <Table.Cell>{stockScrap?.product_variant?.color?.name}</Table.Cell>
                      <Table.Cell>{stockScrap?.product_variant?.size?.name}</Table.Cell>
                      <Table.Cell>
                        <IconButton testId="modal-create-scrap-trash-button"
                          onClick={() => deleteItem(key, values, setFieldValue)}
                          icon={TrashIcon}
                          variant="danger"
                        />
                      </Table.Cell>
                    </Table.BodyRow>
                  ))}
                </Table.Body>
              </Table.Wrapper>
            </Table.Container>

            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-create-scrap-simpan-button" type="submit">Simpan</Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}

export default CreateScrap;
